import { Sparkles, Heart } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer data-testid="footer" className="py-12 px-4 md:px-8 lg:px-16 border-t border-white/5">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Logo */}
          <button 
            onClick={scrollToTop}
            className="flex items-center gap-2 group"
            data-testid="footer-logo"
          >
            <Sparkles className="w-5 h-5 text-rose transition-transform group-hover:rotate-12" />
            <span className="font-heading text-xl">
              <span className="text-rose">Daina</span>
              <span className="text-white">Lanee</span>
            </span>
          </button>

          {/* Social Links */}
          <div className="flex items-center gap-6">
            <a
              href="https://www.instagram.com/dainalaneebrand/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-zinc-400 hover:text-rose transition-colors"
              data-testid="footer-instagram"
            >
              <i className="fab fa-instagram text-2xl" />
            </a>
            <a
              href="tel:7085390789"
              className="text-zinc-400 hover:text-rose transition-colors"
              data-testid="footer-phone"
            >
              <i className="fas fa-phone text-xl" />
            </a>
          </div>

          {/* Copyright */}
          <div className="flex items-center gap-2 text-zinc-500 text-sm">
            <span>© {currentYear} Daina Lanee Brand</span>
            <Heart className="w-3 h-3 text-rose" fill="currentColor" />
            <span>All Rights Reserved</span>
          </div>
        </div>

        {/* Bottom tagline */}
        <div className="mt-8 text-center">
          <p className="font-accent text-xl text-zinc-600">
            Custom Fashion & Unforgettable Experiences
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
